const KeyValueListDisplay = ({
  data,
}: {
  data: { label: string; value: React.ReactNode; valueClassName?: string }[];
}) => {
  return data.map((d, index) => (
    <div key={index} className="flex flex-row justify-between items-start text-sm my-1">
      <div className="font-medium flex-shrink-0 w-1/3">{d?.label}</div>
      <div className={`text-end font-normal w-2/3 break-words ${d.valueClassName}`}>{d?.value}</div>
    </div>
  ));
};
export default KeyValueListDisplay;
